<template>
  <div class="w-100 t-wrapper pt-4 pb-4" style="min-height: 100%">
    <div class="container">
      <div class="h-100 d-flex flex-column align-items-center">
        <h3 class="mm-font text-center mb-1">ဖူးစာဖက်</h3>
        <div class="pane-line"></div>
        <h5 class="text-center mt-2 mb-4 mm-font">
          သင်နှင့်သင့်ချစ်သူ၏ ရာသီခွင်တိုက်ကြည့်ရအောင်
        </h5>

        <div v-if="!result_shown" class="w-100">
          <div class="carousel-row">
            <div class="carousel-body">
              <div v-if="!first_sign_select" class="carousel-placeholder">
                <div
                  v-if="!first_sign_select"
                  class="carousel-placeholder"
                  @pointerdown="startPointerDrag('first', $event)"
                  @pointermove="onPointerDrag('first', $event)"
                  @pointerup="endPointerDrag('first')"
                  @pointercancel="endPointerDrag('first')"
                  @pointerleave="endPointerDrag('first')"
                  @mousedown="startMouseDrag('first', $event)"
                  @mousemove="onMouseDrag('first', $event)"
                  @mouseup="endMouseDrag('first')"
                  @mouseleave="endMouseDrag('first')"
                >
                  <div class="carousel-placeholder-circle"></div>
                  <p class="carousel-placeholder-label">Your sign</p>
                </div>
              </div>
              <div
                v-else
                class="carousel-wheel"
                @pointerdown="startPointerDrag('first', $event)"
                @pointermove="onPointerDrag('first', $event)"
                @pointerup="endPointerDrag('first')"
                @pointercancel="endPointerDrag('first')"
                @pointerleave="endPointerDrag('first')"
                @mousedown="startMouseDrag('first', $event)"
                @mousemove="onMouseDrag('first', $event)"
                @mouseup="endMouseDrag('first')"
                @mouseleave="endMouseDrag('first')"
              >
                <div
                  class="wheel-item"
                  v-for="item in wheelItems('first')"
                  :key="item.value"
                  :style="wheelStyle(item.offset)"
                >
                  <img
                    :src="signImg(item.sign)"
                    :alt="item.sign.eng"
                    class="wheel-img"
                    :class="{ 'wheel-img-main': item.offset === 0 }"
                  />
                  <p v-if="item.offset === 0" class="wheel-range">
                    {{ item.sign.date_range }}
                  </p>
                  <p v-if="item.offset === 0" class="wheel-name mm-font">
                    {{ signLabel(item.sign.eng) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="love-heart-divider">
            <span class="love-heart-icon">&#10084;&#65039;</span>
          </div>

          <div class="carousel-row mt-3">
            <div class="carousel-body">
              <div v-if="!second_sign_select" class="carousel-placeholder">
                <div
                  v-if="!second_sign_select"
                  class="carousel-placeholder"
                  @pointerdown="startPointerDrag('second', $event)"
                  @pointermove="onPointerDrag('second', $event)"
                  @pointerup="endPointerDrag('second')"
                  @pointercancel="endPointerDrag('second')"
                  @pointerleave="endPointerDrag('second')"
                  @mousedown="startMouseDrag('second', $event)"
                  @mousemove="onMouseDrag('second', $event)"
                  @mouseup="endMouseDrag('second')"
                  @mouseleave="endMouseDrag('second')"
                >
                  <div class="carousel-placeholder-circle"></div>
                  <p class="carousel-placeholder-label">Partner's sign</p>
                </div>
              </div>
              <div
                v-else
                class="carousel-wheel"
                @pointerdown="startPointerDrag('second', $event)"
                @pointermove="onPointerDrag('second', $event)"
                @pointerup="endPointerDrag('second')"
                @pointercancel="endPointerDrag('second')"
                @pointerleave="endPointerDrag('second')"
                @mousedown="startMouseDrag('second', $event)"
                @mousemove="onMouseDrag('second', $event)"
                @mouseup="endMouseDrag('second')"
                @mouseleave="endMouseDrag('second')"
              >
                <div
                  class="wheel-item"
                  v-for="item in wheelItems('second')"
                  :key="item.value"
                  :style="wheelStyle(item.offset, true)"
                >
                  <img
                    :src="signImg(item.sign)"
                    :alt="item.sign.eng"
                    class="wheel-img"
                    :class="{ 'wheel-img-main': item.offset === 0 }"
                  />
                  <p v-if="item.offset === 0" class="wheel-range">
                    {{ item.sign.date_range }}
                  </p>
                  <p v-if="item.offset === 0" class="wheel-name mm-font">
                    {{ signLabel(item.sign.eng) }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div
            class="mt-4 d-flex justify-content-center align-items-center p-2"
            style="gap: 20px; flex-wrap: wrap"
          >
            <span class="love-btn" @click="reset()">ပြန်လည်စတင်မည်</span>
            <span
              class="love-btn love-btn-primary"
              :class="{ 'love-btn-disabled': !canCalculate }"
              id="love-calculate"
              @click="calculate()"
              >အခု စစ်ဆေးမယ်</span
            >
          </div>
        </div>

        <div v-if="loading" class="w-100 loading-section">
          <img
            :src="loadingGif"
            style="width: 40px"
            height="40px"
          />
          <p class="mm-font loading-text">
            စစ်ဆေးမှုများလုပ်ဆောင်နေပါသည်။ ခေတ္တခဏစောင့်ပေးပါ
          </p>
          <div class="fan-stage" v-if="signs.length">
            <div
              v-for="(sign, i) in signs"
              :key="sign.value"
              class="fan-card"
              :style="fanSlot(i)"
            >
              <img :src="signImg(sign)" :alt="sign.eng" class="fan-img" />
            </div>
          </div>
        </div>

        <div v-if="result_shown && !loading" class="w-100 result-section">
          <div class="result-pair">
            <div class="result-pair-side" v-if="firstSign">
              <img :src="signImg(firstSign)" :alt="firstSign.eng" />
              <p class="mm-font">{{ signLabel(firstSign.eng) }}</p>
            </div>
            <div class="result-sparkle">&#10024;</div>
            <div class="result-pair-side" v-if="secondSign">
              <img :src="signImg(secondSign)" :alt="secondSign.eng" />
              <p class="mm-font">{{ signLabel(secondSign.eng) }}</p>
            </div>
          </div>

          <div class="overall-card">
            <div class="overall-top">
              <span class="overall-heart">&#10084;&#65039;</span>
              <span class="overall-value">{{ overall }}%</span>
              <span class="overall-badge">{{ badge }}</span>
            </div>
            <div class="overall-track">
              <div class="overall-fill" :style="{ width: overall + '%' }"></div>
            </div>
          </div>

          <div class="rings-grid">
            <div class="ring-item" v-for="m in metrics" :key="m.key">
              <svg class="ring" viewBox="0 0 120 120" width="96" height="96">
                <circle
                  cx="60"
                  cy="60"
                  r="52"
                  fill="none"
                  stroke="#e5e7eb"
                  stroke-width="10"
                />
                <circle
                  cx="60"
                  cy="60"
                  r="52"
                  fill="none"
                  :stroke="m.color"
                  stroke-width="10"
                  stroke-linecap="round"
                  :stroke-dasharray="ringDash"
                  :stroke-dashoffset="ringOffset(result[m.key] || 0)"
                  transform="rotate(-90 60 60)"
                />
              </svg>
              <div class="ring-value">{{ result[m.key] || 0 }}%</div>
              <p class="ring-label">{{ m.label }}</p>
            </div>
          </div>

          <div v-if="result.summary" class="result-summary">
            <p class="mm-font result-label">ဖတ်ကြားချက်</p>
            <p class="mm-font result-text">{{ result.summary }}</p>
          </div>

          <span class="mt-3 back-btn" @click="back">&#8592; back</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Horo } from "@core/lib/http-common";

const SIGN_MM = {
  Aries: "မိဿ",
  Taurus: "ပြိဿ",
  Gemini: "မေထုန်",
  Cancer: "ကရကဋ်",
  Leo: "သိဟ်",
  Virgo: "ကန်",
  Libra: "တူ",
  Scorpio: "ဗြိစ္ဆာ",
  Sagittarius: "ဓနု",
  Capricorn: "မကာရ",
  Aquarius: "ကုံ",
  Pisces: "မိန်",
};

const SIGN_IMAGES = {
  Aries: require("@/images/love_calculator/Aries.png"),
  Taurus: require("@/images/love_calculator/Taurus.png"),
  Gemini: require("@/images/love_calculator/Gemini.png"),
  Cancer: require("@/images/love_calculator/Cancer.png"),
  Leo: require("@/images/love_calculator/Leo.png"),
  Virgo: require("@/images/love_calculator/Virgo.png"),
  Libra: require("@/images/love_calculator/Libra.png"),
  Scorpio: require("@/images/love_calculator/Scorpio.png"),
  Sagittarius: require("@/images/love_calculator/Sagittarius.png"),
  Capricorn: require("@/images/love_calculator/Capricorn.png"),
  Aquarius: require("@/images/love_calculator/Aquarius.png"),
  Pisces: require("@/images/love_calculator/Pisces.png"),
};

export default {
  name: "CompatabilityLove",
  data() {
    return {
      signs: [],
      first_index: -1,
      second_index: -1,
      first_sign_select: false,
      second_sign_select: false,
      first_sign_id: null,
      second_sign_id: null,
      dragSlot: null,
      dragStartX: 0,
      dragAccum: 0,
      lastDragStep: 0,
      loadingGif: require("@/images/love_calculator/heart.gif"),
      result_shown: false,
      loading: false,
      result: {
        love: 0,
        fight: 0,
        sex: 0,
        care: 0,
        summary: "",
      },
    };
  },

  beforeRouteLeave(to, from, next) {
    this.$swal({
      title: "ထွက်ခွာမည်မှာ သေချာပါသလား?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "ထွက်မည်",
      cancelButtonText: "မထွက်တော့ပါ",
      customClass: {
        popup: "leave-confirm-popup",
        confirmButton: "leave-confirm-confirm",
        cancelButton: "leave-confirm-cancel",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        next();
      } else {
        next(false);
      }
    });
  },

  computed: {
    firstSign() {
      return this.first_index >= 0 ? this.signs[this.first_index] : null;
    },
    secondSign() {
      return this.second_index >= 0 ? this.signs[this.second_index] : null;
    },
    canCalculate() {
      return this.first_sign_select && this.second_sign_select;
    },
    ringDash() {
      return (2 * Math.PI * 52).toFixed(1);
    },
    metrics() {
      return [
        { key: "love", label: "Love", color: "#ff9ab8" },
        { key: "fight", label: "Fight", color: "#6fce7f" },
        { key: "sex", label: "Sex", color: "#7ba6ff" },
        { key: "care", label: "Care", color: "#f2c14e" },
      ];
    },
    overall() {
      const love = this.result.love || 0;
      const fight = this.result.fight || 0;
      const sex = this.result.sex || 0;
      const care = this.result.care || 0;
      const denominator = love + fight + sex + care;
      if (denominator <= 0) return 0;
      const score = ((love + sex + care) / denominator) * 100;
      return Math.round(Math.max(0, Math.min(100, score)));
    },
    badge() {
      const score = this.overall;
      if (score >= 80) return "Excellent";
      if (score >= 70) return "Good";
      if (score >= 60) return "Moderate";
      return "Challenging";
    },
  },

  async created() {
    try {
      const res = await axios.post(
        "https://1875services.boom.com.mm/api/signs",
      );
      this.signs = Array.isArray(res.data) ? res.data : [];
      if (this.signs.length) {
        this.first_index = 0;
        this.first_sign_id = this.signs[0].value;
        this.first_sign_select = true;
      }
      if (this.signs.length > 1) {
        this.second_index = 1;
        this.second_sign_id = this.signs[1].value;
        this.second_sign_select = true;
      }
    } catch (e) {
      this.signs = [];
    }
  },

  methods: {
    signImg(sign) {
      return SIGN_IMAGES[sign.eng] || null;
    },
    signMm(eng) {
      return SIGN_MM[eng] || eng;
    },
    signLabel(eng) {
      return `${this.signMm(eng)} (${eng})`;
    },
    ringOffset(pct) {
      const circumference = 2 * Math.PI * 52;
      const value = Math.max(0, Math.min(100, Number(pct) || 0));
      return (circumference * (1 - value / 100)).toFixed(1);
    },
    fanSlot(i) {
      const count = 12;
      const angle = -75 + (i / (count - 1)) * 150;
      const rad = (angle * Math.PI) / 180;
      const radius = 105;
      const tx = Math.sin(rad) * radius;
      const ty = Math.cos(rad) * radius * 0.55;
      const rot = -angle * 0.5;
      const z = 12 - Math.abs(i - (count - 1) / 2) * 2;
      return {
        "--tx": `${tx.toFixed(1)}px`,
        "--ty": `${ty.toFixed(1)}px`,
        "--rot": `${rot.toFixed(1)}deg`,
        "--delay": `${(i * 0.16).toFixed(2)}s`,
        zIndex: z,
      };
    },
    stepCarousel(slot, dir) {
      if (!this.signs.length) return;
      const indexKey = slot === "first" ? "first_index" : "second_index";
      const idKey = slot === "first" ? "first_sign_id" : "second_sign_id";
      const selectKey =
        slot === "first" ? "first_sign_select" : "second_sign_select";
      if (this[indexKey] === -1) {
        this[indexKey] = dir > 0 ? 0 : this.signs.length - 1;
      } else {
        this[indexKey] =
          (this[indexKey] + dir + this.signs.length) % this.signs.length;
      }
      this[idKey] = this.signs[this[indexKey]].value;
      this[selectKey] = true;
    },

    wheelItems(slot) {
      const list = this.signs;
      const indexKey = slot === "first" ? "first_index" : "second_index";
      const selected = this[indexKey];
      if (!list.length || selected < 0) return [];
      const items = [];
      for (let offset = -2; offset <= 2; offset++) {
        const idx = (selected + offset + list.length) % list.length;
        items.push({ sign: list[idx], value: list[idx].value, offset });
      }
      return items.sort((a, b) => a.value - b.value);
    },

    wheelStyle(offset, reverse) {
      const isMobile =
        typeof window !== "undefined" && window.innerWidth <= 768;
      const spacing = isMobile ? 62 : 130;
      const arc = isMobile ? 9 : 14;
      const dir = reverse ? 1 : -1;
      const abs = Math.abs(offset);
      const x = offset * spacing;
      const y = dir * offset * offset * arc;
      const angle = dir * offset * 16;
      const scale = 1 - abs * 0.2;
      const opacity = 1 - abs * 0.28;
      const grayscale = abs * 0.5;
      return {
        transform: `translate(${x}px, ${y}px) rotate(${angle}deg) scale(${scale})`,
        opacity,
        zIndex: 10 - abs,
        filter: grayscale > 0 ? `grayscale(${grayscale})` : "none",
      };
    },

    beginDrag(slot, clientX) {
      if (!this.signs.length || this.dragSlot) return;
      this.dragSlot = slot;
      this.dragStartX = clientX;
      this.dragAccum = 0;
      this.lastDragStep = 0;
    },

    applyDrag(slot, clientX) {
      if (this.dragSlot !== slot) return;
      this.dragAccum += clientX - this.dragStartX;
      this.dragStartX = clientX;
      const step = 46;
      const now = Date.now();
      while (
        Math.abs(this.dragAccum) >= step &&
        now - this.lastDragStep >= 150
      ) {
        this.stepCarousel(slot, this.dragAccum > 0 ? -1 : 1);
        this.dragAccum =
          this.dragAccum > 0 ? this.dragAccum - step : this.dragAccum + step;
        this.lastDragStep = now;
      }
    },

    endDrag(slot) {
      if (this.dragSlot !== slot) return;
      this.dragSlot = null;
      this.dragAccum = 0;
    },

    startPointerDrag(slot, event) {
      this.beginDrag(slot, event.clientX);
    },

    onPointerDrag(slot, event) {
      this.applyDrag(slot, event.clientX);
    },

    endPointerDrag(slot) {
      this.endDrag(slot);
    },

    startMouseDrag(slot, event) {
      if (typeof window !== "undefined" && window.PointerEvent) return;
      this.beginDrag(slot, event.clientX);
    },

    onMouseDrag(slot, event) {
      if (typeof window !== "undefined" && window.PointerEvent) return;
      this.applyDrag(slot, event.clientX);
    },

    endMouseDrag(slot) {
      if (typeof window !== "undefined" && window.PointerEvent) return;
      this.endDrag(slot);
    },

    reset() {
      this.first_index = -1;
      this.second_index = -1;
      this.first_sign_select = false;
      this.second_sign_select = false;
      this.first_sign_id = null;
      this.second_sign_id = null;
    },

    back() {
      this.$router.push({
        name: "withPaymenthome",
        params: {
          payment: this.$route.query.payment,
        },
      });
    },

    async calculate() {
      if (!this.canCalculate) return;
      this.showLoading();
      const [result] = await Promise.all([
        this.getResult(),
        new Promise((resolve) => setTimeout(resolve, 3000)),
      ]);
      this.showResult(result);
    },

    async getResult() {
      try {
        const resp = await Horo.post("1875/zodiac-compatibility/result", {
          sign1: this.firstSign.eng,
          sign2: this.secondSign.eng,
        });
        return (resp.data && resp.data.data) || {};
      } catch (e) {
        try {
          const resp = await axios.post(
            `https://1875services.boom.com.mm/api/compatability-love-result/${this.first_sign_id}/${this.second_sign_id}`,
          );
          return resp.data || {};
        } catch (err) {
          return {};
        }
      }
    },

    showLoading() {
      this.loading = true;
      this.result_shown = true;
    },

    showResult(result) {
      this.loading = false;
      this.result = Object.assign(
        { love: 0, fight: 0, sex: 0, care: 0, summary: "" },
        result,
      );
    },
  },
};
</script>

<style scoped>
.t-wrapper {
  color: #1f2937;
}

.mm-font {
  font-family: "Padauk", sans-serif;
  line-height: 175%;
}

div.pane-line {
  width: 50px;
  height: 5px;
  border-radius: 30px;
  background: #ff7010 !important;
}

.carousel-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.carousel-arrow {
  outline: none;
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  color: #1f2937;
  border-radius: 50%;
  font-size: 24px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(31, 41, 55, 0.08);
  position: relative;
  z-index: 20;
}

.carousel-arrow:active {
  opacity: 0.7;
}

.carousel-body {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 150px;
  overflow: visible;
}

.carousel-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
  cursor: pointer;
}

.love-heart-divider {
  display: flex;
  justify-content: center;
  margin: 4px 0;
}

.love-heart-icon {
  font-size: 22px;
  display: inline-block;
  animation: heartbeat 1.1s ease-in-out infinite;
}

@keyframes heartbeat {
  0%,
  100% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.25);
  }
  40% {
    transform: scale(1);
  }
  60% {
    transform: scale(1.15);
  }
}

.carousel-placeholder-circle {
  width: 110px;
  height: 110px;
  border: 2px dashed #c4ccd6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-placeholder-label {
  margin: 0;
  font-size: 14px;
  color: #9aa3ad;
}

.carousel-wheel {
  position: relative;
  width: 100%;
  height: 150px;
  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
}

.wheel-item {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 96px;
  height: 96px;
  margin: -48px 0 0 -48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.6s cubic-bezier(0.22, 1, 0.36, 1),
    opacity 0.6s cubic-bezier(0.22, 1, 0.36, 1), filter 0.6s ease;
  will-change: transform;
}

.wheel-img {
  width: 88px;
  height: 88px;
  object-fit: contain;
  display: block;
  pointer-events: none;
}

.wheel-range {
  position: absolute;
  top: -20px;
  left: 0;
  width: 100%;
  margin: 0;
  text-align: center;
  font-size: 11px;
  color: #6b7280;
  pointer-events: none;
}

.wheel-name {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  margin: 4px 0 0;
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  color: #1f2937;
  pointer-events: none;
  white-space: nowrap;
}

.carousel-caption {
  margin: 6px 0 0;
  font-size: 13px;
  color: #9aa3ad;
  text-align: center;
}

.love-btn {
  outline: none;
  border: 1px solid #ff7010;
  padding: 8px 16px;
  background: #ffffff;
  color: #ff7010;
  border-radius: 30px;
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;
}

.love-btn:active {
  opacity: 0.7;
}

.love-btn-primary {
  background: #ff7010;
  color: #ffffff;
}

.love-btn-disabled {
  opacity: 0.45;
  pointer-events: none;
}

.loading-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  min-height: 340px;
  padding: 24px 0;
}

.loading-text {
  margin: 0;
  font-size: 15px;
  color: #4b5563;
  text-align: center;
}

.fan-stage {
  position: relative;
  width: 330px;
  height: 150px;
  overflow: visible;
  margin: 4px 0;
}

.fan-card {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 48px;
  height: 48px;
  margin: -24px 0 0 -24px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  animation: fan-wave 2.6s ease-in-out var(--delay) infinite;
  will-change: transform, opacity;
}

.fan-img {
  width: 44px;
  height: 44px;
  object-fit: contain;
  display: block;
}

@keyframes fan-wave {
  0% {
    transform: translate(0, 0) rotate(0deg) scale(0.5);
    opacity: 0;
  }

  45% {
    transform: translate(var(--tx), var(--ty)) rotate(var(--rot)) scale(1);
    opacity: 1;
  }

  90% {
    transform: translate(var(--tx), var(--ty)) rotate(var(--rot)) scale(1);
    opacity: 1;
  }

  100% {
    transform: translate(0, 0) rotate(0deg) scale(0.5);
    opacity: 0;
  }
}

.result-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.result-pair {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
}

.result-pair-side {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.result-pair-side img {
  width: 72px;
  height: 72px;
  object-fit: contain;
}

.result-pair-side p {
  margin: 4px 0 0;
  font-size: 12px;
  font-weight: 600;
  color: #1f2937;
  white-space: nowrap;
}

.result-sparkle {
  font-size: 22px;
}

.overall-card {
  width: 100%;
  max-width: 340px;
  background: #ffffff;
  border: 1px solid #ffe0c7;
  border-radius: 16px;
  padding: 16px;
  text-align: center;
}

.overall-top {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.overall-heart {
  font-size: 22px;
}

.overall-value {
  font-size: 34px;
  font-weight: 700;
  color: #ff7010;
}

.overall-badge {
  font-size: 13px;
  color: #6b7280;
  border: 1px solid #ffd9bd;
  border-radius: 20px;
  padding: 3px 10px;
}

.overall-track {
  height: 10px;
  background: #ffe9d8;
  border-radius: 20px;
  overflow: hidden;
  margin-top: 12px;
}

.overall-fill {
  height: 100%;
  background: linear-gradient(90deg, #ff7010, #ffb066);
  border-radius: 20px;
  transition: width 1s ease;
}

.rings-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  width: 100%;
  max-width: 360px;
  margin-top: 24px;
}

.ring-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.ring-value {
  position: absolute;
  left: 50%;
  top: 48px;
  transform: translate(-50%, -50%);
  font-size: 17px;
  font-weight: 700;
  color: #1f2937;
}

.ring-label {
  margin: 6px 0 0;
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
}

.result-summary {
  width: 100%;
  max-width: 360px;
  margin-top: 22px;
  text-align: left;
}

.result-label {
  margin: 0 0 6px;
  color: #ff7010;
  font-weight: 600;
}

.result-text {
  margin: 0;
  font-size: 14px;
  color: #374151;
  white-space: pre-wrap;
}

.back-btn {
  cursor: pointer;
}
</style>
